// Galerie d'avatars du PROFIL — le joueur choisit son visage.
//
// ⚠️ CE N'EST PAS DU CONTENU NARRATIF. Ces visages étaient extraits de `storyCharacters.ts`,
// qui indexait les personnages PAR HISTOIRE avec leur rôle, leur ethnie et leur description —
// une copie de ce que la base porte déjà, et une source concurrente : l'entrée locale gagnait
// sur la photo choisie par l'auteur et masquait toute erreur de résolution côté runtime.
//
// Il n'en reste que ce dont l'application a réellement besoin : un nom et une image, pour la
// grille de choix d'avatar. Aucun rôle, aucune description, aucune clé d'histoire.
//
// Les images sont des URL du même conteneur que la Gallery — zéro octet dans le bundle.
//
// À TERME : cette liste devrait venir de la Gallery par API, comme le reste des médias. Elle
// est ici parce qu'aucune route ne la sert encore, pas parce que c'est le bon endroit.
const BLOB = "https://ccpubmedia.blob.core.windows.net/characters/";

export interface AvatarProfil {
  name: string;
  avatar: { uri: string };
}

export const ALL_CHARACTERS: AvatarProfil[] = [
  { name: "Nina", avatar: { uri: BLOB + "egocrisis_nina.jpg" } },
  { name: "Raoul", avatar: { uri: BLOB + "egocrisis_raoul.jpg" } },
  { name: "Youssef", avatar: { uri: BLOB + "egocrisis_youssef.jpg" } },
  { name: "Anna", avatar: { uri: BLOB + "egocrisis_anna.jpg" } },
  { name: "Emilie", avatar: { uri: BLOB + "egocrisis_emilie.jpg" } },
  { name: "Darius", avatar: { uri: BLOB + "egocrisis_darius_man_30s.jpg" } },
  { name: "Samir", avatar: { uri: BLOB + "foundation_gamble_samir_man_40s.jpg" } },
  { name: "Tarek", avatar: { uri: BLOB + "foundation_gamble_tarek_man_40s.jpg" } },
  { name: "Lucas", avatar: { uri: BLOB + "foundation_gamble_lucas_man_30s.jpg" } },
  { name: "Kwame", avatar: { uri: BLOB + "foundation_gamble_kwame_man_30s.jpg" } },
  { name: "James", avatar: { uri: BLOB + "foundation_gamble_james_man_30s.jpg" } },
  { name: "Mina Brown", avatar: { uri: BLOB + "architecture_under_fire_Mina_Brown.jpg" } },
  { name: "Karim Belkacem", avatar: { uri: BLOB + "architecture_under_fire_Hugo_Petit.jpg" } },
  { name: "Samir Idrissi", avatar: { uri: BLOB + "architecture_under_fire_Samir_Idrissi.jpg" } },
  { name: "Diane Leclerc", avatar: { uri: BLOB + "architecture_under_fire_Diane_Leclerc.jpg" } },
  { name: "Aisha", avatar: { uri: BLOB + "data_storm_aisha_woman_30s.jpg" } },
  { name: "Marcus", avatar: { uri: BLOB + "data_storm_marcus_man_30s.jpg" } },
  { name: "Darius", avatar: { uri: BLOB + "data_storm_darius_man_30s.jpg" } },
  { name: "Jun", avatar: { uri: BLOB + "data_storm_jun_woman_30s.jpg" } },
  { name: "Soo-Min", avatar: { uri: BLOB + "data_storm_soo-min_woman_30s.jpg" } },
  { name: "Keiko", avatar: { uri: BLOB + "cloud_heist_keiko_woman_30s.jpg" } },
  { name: "Nabil", avatar: { uri: BLOB + "cloud_heist_nabil_man_40s.jpg" } },
  { name: "Leila", avatar: { uri: BLOB + "cloud_heist_leila_woman_30s.jpg" } },
  { name: "Yasmine", avatar: { uri: BLOB + "cloud_heist_yasmine_woman_30s.jpg" } },
  { name: "Karim", avatar: { uri: BLOB + "neural_override_karim_man_40s.jpg" } },
  { name: "Fatima", avatar: { uri: BLOB + "neural_override_fatima_woman_30s.jpg" } },
  { name: "Amira", avatar: { uri: BLOB + "neural_override_amira_woman_30s.jpg" } },
  { name: "Erik", avatar: { uri: BLOB + "neural_override_erik_man_30s.jpg" } },
  { name: "Viktor", avatar: { uri: BLOB + "pipeline_inferno_viktor_man_30s.jpg" } },
  { name: "Liwei", avatar: { uri: BLOB + "pipeline_inferno_liwei_woman_30s.jpg" } },
  { name: "Priya", avatar: { uri: BLOB + "pipeline_inferno_priya_woman_30s.jpg" } },
  { name: "Katya", avatar: { uri: BLOB + "pipeline_inferno_katya_woman_20s.jpg" } },
  { name: "Priya", avatar: { uri: BLOB + "merge_conflict_priya_woman_30s.jpg" } },
  { name: "Marcus", avatar: { uri: BLOB + "merge_conflict_marcus_man_30s.jpg" } },
  { name: "Viktor", avatar: { uri: BLOB + "merge_conflict_viktor_man_30s.jpg" } },
  { name: "Olga", avatar: { uri: BLOB + "merge_conflict_olga_woman_40s.jpg" } },
  { name: "Sakura", avatar: { uri: BLOB + "deadline_paradox_sakura_woman_30s.jpg" } },
  { name: "Kwame", avatar: { uri: BLOB + "deadline_paradox_kwame_man_30s.jpg" } },
  { name: "Nyah", avatar: { uri: BLOB + "deadline_paradox_nyah_woman_30s.jpg" } },
  { name: "Kenji", avatar: { uri: BLOB + "deadline_paradox_kenji_man_30s.jpg" } },
  { name: "Tarek", avatar: { uri: BLOB + "arabic_modern_tarek_man_40s.jpg" } },
  { name: "Leila", avatar: { uri: BLOB + "arabic_modern_leila_woman_30s.jpg" } },
  { name: "Natasha", avatar: { uri: BLOB + "arabic_modern_natasha_woman_40s.jpg" } },
  { name: "Viktor", avatar: { uri: BLOB + "arabic_modern_viktor_man_30s.jpg" } },
];
